// 获取投资信息列表
export const GETFINANCELIST = 'get-finance-list'
// 获取项目分类列表
export const GETPRODUCTTYPE = 'get-product-type'
// 获取项目详情
export const GETPRODUCTDETAIL = 'get-product-detail'
